import _defineProperty from "/ecomm-marketplace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable i18next/no-literal-string */
import _invert from 'lodash/invert';
export var countryMap = {
  US: 'United States',
  CA: 'Canada',
  JM: 'Jamaica',
  VC: 'Saint Vincent and the Grenadines'
};
export var countryMapToShortened = _invert(countryMap);
export var jamaicanParishesMap = {
  '01': 'Kingston Parish',
  '02': 'St. Andrew Parish',
  '03': 'St. Thomas Parish',
  '04': 'Portland Parish',
  '05': 'St. Mary Parish',
  '06': 'St. Ann Parish',
  '07': 'Trelawny Parish',
  '08': 'St. James Parish',
  '09': 'Hanover Parish',
  10: 'Westmoreland Parish',
  11: 'St. Elizabeth Parish',
  12: 'Manchester Parish',
  13: 'Clarendon',
  14: 'St. Catherine Parish'
};
export var jamaicanParishesMapToShortened = _invert(jamaicanParishesMap);
export var saintVincentAndTheGrenadinesParishesMap = {
  '01': 'Charlotte',
  '02': 'St. Andrew',
  '03': 'St. David',
  '04': 'St. George',
  '05': 'St. Patrick',
  '06': 'Grenadines'
};
export var saintVincentAndTheGrenadinesParishesMapToShortened = _invert(saintVincentAndTheGrenadinesParishesMap);
export var canadianProvincesMap = {
  AB: 'Alberta',
  BC: 'British Columbia',
  MB: 'Manitoba',
  NB: 'New Brunswick',
  NL: 'Newfoundland and Labrador',
  NS: 'Nova Scotia',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
  ON: 'Ontario',
  PE: 'Prince Edward Island',
  QC: 'Québec',
  SK: 'Saskatchewan',
  YT: 'Yukon'
};
export var puertoRicoMapToShortened = {
  Humacao: 'PR',
  Naguabo: 'PR',
  'San Juan': 'PR'
};
export var canadianProvincesMapToShortened = _objectSpread(_objectSpread({}, _invert(canadianProvincesMap)), {}, {
  Quebec: 'QC'
});
export var USStatesMap = {
  AL: 'Alabama',
  AK: 'Alaska',
  AR: 'Arkansas',
  AS: 'American Samoa',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WY: 'Wyoming'
};
export var USStatesMapToShortened = _objectSpread(_objectSpread({}, _invert(USStatesMap)), {}, {
  DC: 'DC'
});
export var countryToStateMap = {
  US: USStatesMap,
  CA: canadianProvincesMap,
  JM: jamaicanParishesMap,
  VC: saintVincentAndTheGrenadinesParishesMap
};
export var countryToShortenedStateMap = {
  'United States': USStatesMapToShortened,
  'Puerto Rico': puertoRicoMapToShortened,
  Canada: canadianProvincesMapToShortened,
  Jamaica: jamaicanParishesMapToShortened,
  'Saint Vincent and the Grenadines': saintVincentAndTheGrenadinesParishesMapToShortened
};
/**
 * Cities for which we can't create a city page
 *
 * {
 *  stateCode: ['City Name', 'City Name']
 * }
 *
 * stateCode should be the ISO code for the state in which the city is located
 * 'City Name' should match what's in the DB exactly (spelling/capitalization)
 *
 * Please leave a reason for why it's unsupported in a comment beside the entry
 */

export var unsupportedCities = {
  PR: ['Humacao'] // Reason: can't find a way to get Mapbox to return the actual city

};